export default __webpack_public_path__ + "static/media/uploader-abbottXtra-2.b4fa7b25.png";